<template>
  <div class="font-14 color-555 get-start-wrap">
    <!--<div class="get-start-btm-wrap">
      <div class="font-16 text-bold get-start-desc">
        <p>{{ $t('landing.getStarted.desc') }}</p>
      </div>
    </div>-->

    <div class="get-video-title-wrap">
      <div class="text-bold text-center get-video-title">
        <p>{{ $t('landing.video.title') }}</p>
      </div>
    </div>

    <div class="get-video-wrap">
      <div class="get-start-wallet" style="position: relative">
        <div class="get-video-img">
          <img src="../../assets/images/home/video-thumbnail.jpg" alt />
          <!-- <a class="play-video" :href="videoLink" target="_blank"><img src="../../assets/images/home/play-icon.png" alt=""/></a> -->
          <div class="play-video" @click="openMagnificPopUp"><img src="../../assets/images/home/play-icon.png" alt="" /></div>
        </div>
      </div>

      <v-dialog v-model="magnificPopUp" width="100%">
        <v-card color="transparent" class="magnific-card">
          <div class="magnific-content">
            <iframe
              class="magnific-video"
              width="1280"
              height="720"
              :src="embedVideoLink"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; "
              allowfullscreen
            ></iframe>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { commonApi } from '../../api/commonApi';

export default {
  name: 'VideoSection',
  data() {
    return {
      appDemoBg: require('@/assets/images/home/app_demo.png'),
      walletBg: require('@/assets/images/home/max-wallet.png'),
      tickImg: require('@/assets/images/tick.svg'),
      cipherBg: require('@/assets/images/home/cipher-trace.png'),
      btnList: {
        grx_ios_store: { icon: require('@/assets/images/home/grx_ios_store.svg'), path: '' },
        grx_android_store: { icon: require('@/assets/images/home/grx_android_store.svg'), path: '' },
        grx_ipa: { icon: require('@/assets/images/home/grx_ios_ipa.svg'), path: '' },
        grx_apk: { icon: require('@/assets/images/home/grx_android_apk.svg'), path: '' }
      },
      currentCoin: 'GRX',
      list: [
        {
          icon: require('@/assets/images/home/get_start_1.png'),
          title: this.$t('landing.getStarted.sec.1'),
          desc: this.$t('landing.getStarted.desc.1')
        },
        {
          icon: require('@/assets/images/home/get_start_2.png'),
          title: this.$t('landing.getStarted.sec.2'),
          desc: this.$t('landing.getStarted.desc.2')
        },
        {
          icon: require('@/assets/images/home/get_start_3.png'),
          title: this.$t('landing.getStarted.sec.3'),
          desc: this.$t('landing.getStarted.desc.3')
        }
      ],
      videoLink: '',
      defaultVideoLink: 'https://youtu.be/3VKjXSPtRCM',
      magnificPopUp: false
    };
  },
  mounted() {
    this.videoLink = window.env.videoLinkEn || this.defaultVideoLink;
    // commonApi.getIpAddress().then(res => {
    //   let data = res.data;
    //   if (data.country === '中国') {
    //     this.videoLink = window.env.videoLinkCn || this.defaultVideoLink;
    //   }
    // });
  },
  watch: {
    magnificPopUp(val) {
      if (!val) {
        this.stopVideo(document.querySelector('.magnific-content'));
      }
    }
  },
  computed: {
    embedVideoLink() {
      if (this.videoLink) {
        let id = this.getId(this.videoLink);
        return 'https://www.youtube.com/embed/' + id;
      }
    }
  },
  methods: {
    openMagnificPopUp() {
      this.magnificPopUp = true;
    },
    stopVideo(element) {
      var iframe = element.querySelector('iframe');
      var video = element.querySelector('video');
      if (iframe) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
      if (video) {
        video.pause();
      }
    },
    getId(url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      // console.log(match);
      if (match && match[2].length == 11) {
        return match[2];
      } else {
        return 'error';
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.get-start-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 25px 50px;
}

.get-start-top-wrap {
  display: flex;
  justify-content: center;
  padding: 84px 15px 0;
}

.get-start-top-wrap > div {
  /* flex: 1 1 0px; */
  max-width: 800px;
}

.get-start-title {
  font-size: 30px;
  color: rgba(85, 85, 85, 1);
  padding: 0 15px 13px;
}

.get-start-view-all {
  font-size: 14px;
  color: rgba(85, 85, 85, 1);
  padding-bottom: 15px;
}

.get-start-list {
  display: flex;
  flex-direction: column;
}

.get-start-list > li {
  display: flex;
  align-items: center;
  padding: 15px 0;
}

.get-start-list-icon {
  flex: 0 0 64px;
}

.get-start-list-title {
  font-size: 16px;
  font-weight: bold;
  color: rgba(85, 85, 85, 1);
}

.get-start-list-desc {
  font-size: 14px;
  color: rgba(170, 170, 170, 1);
}

.get-start-btn {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.get-start-btn a {
  cursor: pointer;
  width: 140px;
  height: 45px;
  opacity: 1;
  border-radius: 4px;
  margin: 20px;
}

.get-start-btn a img {
  width: 100%;
}

.get-start-btn a:active {
  opacity: 0.9;
}

.get-start-btm-wrap {
  padding: 0 15%;
}

.get-start-desc {
  text-align: center;
}

.get-video-title {
  padding: 100px 15px 0px;
  font-size: 30px;
}

.get-video-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  text-align: center;
}

.get-video-wrap > div {
  flex-basis: 700px;
  padding: 50px 15px 0;
}

.get-start-wallet,
.get-start-cipher {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.play-video {
  height: 80px;
  width: 80px;
  position: absolute;
  left: 50%;
  margin-left: -41px;
  top: 55%;
  margin-top: -36px;
  opacity: 0.5;
  border-radius: 50%;
  cursor: pointer;
}

.play-video:hover {
  opacity: 1;
  -webkit-box-shadow: 0 8px 6px -6px black;
  -moz-box-shadow: 0 8px 6px -6px black;
  box-shadow: -2px -1px 15px 16px rgba(0, 0, 0, 0.35);
}

.get-video-img {
  padding-bottom: 20px;
  max-width: 700px;
  height: auto;
  display: flex;
  align-items: center;
}

.get-video-img > img {
  max-width: 100%;
  max-height: 600px;
}

.get-video-desc {
  padding-top: 20px;
}

.max-link {
  color: blue;
  text-decoration: underline;
}

.max-link:visited {
  color: rgba(17, 21, 34, 0.9);
}

.magnific-content{
  width: 100%;
  height: 56.25vw;
  max-height: 85vh;
}

.magnific-video{
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 1200px) {
  .get-start-top-wrap {
    flex-direction: column;
    align-items: center;
  }

  .get-start-top-wrap > div:nth-child(1) {
    max-width: 300px;
  }

  .get-start-title {
    text-align: center;
  }

  .get-start-btn {
    justify-content: center;
  }

  .get-start-list {
    padding: 0 50px;
  }
}

@media screen and (max-width: 576px) {
  .get-start-list > li {
    align-items: flex-start;
  }

  .get-start-list-icon {
    margin-top: 10px;
  }

  .get-start-list {
    padding: 0px 25px;
  }

  ::v-deep .v-dialog{
    margin: 0px;
  }
}
</style>
